<highcharts-chart 
    [Highcharts]="Highcharts" 
    [options]="chartOptions"
    [(update)]="updateValue"
    [callbackFunction]="chartCallBack">
</highcharts-chart>
